var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      staticClass: "fullWidthCardRes",
      attrs: { disabled: false, footerPadding: "px-0" },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "flex gap-1 w-full skills-footer items-center px-4 mt-2 cardBorder",
                },
                [
                  _vm._v(" Skills: "),
                  _vm.skill.length > 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row gap-1 items-center" },
                        [
                          _vm._l(_vm.skill.slice(0, 3), function (sk) {
                            return _c(
                              "div",
                              {
                                key: sk.skill.name,
                                staticClass: "skills-chip",
                              },
                              [_vm._v(" " + _vm._s(sk.skill.name) + " ")]
                            )
                          }),
                          _vm.skill.length > 3
                            ? _c("div", [
                                _c("div", { staticClass: "skills-chip-plus" }, [
                                  _vm._v(
                                    " +" + _vm._s(_vm.skill.length - 3) + " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.skill.length === 0
                    ? _c("div", [_vm._v("n/a")])
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "flex flex-col w-full p-4 pb-0" }, [
        _c(
          "div",
          { staticClass: "flex flex-row justify-between items-start pb-2" },
          [
            _c(
              "div",
              { staticClass: "flex flex-col gap-2" },
              [
                !_vm.isEmailUnconfirmed && !_vm.user.archived
                  ? _c("Badge", {
                      staticClass: "text-badge capitalize",
                      attrs: { color: _vm.BadgeColor.ACTIVE, value: "Active" },
                    })
                  : _vm._e(),
                _vm.isEmailUnconfirmed && !_vm.user.archived
                  ? _c("Badge", {
                      attrs: {
                        color: _vm.BadgeColor.WARNING,
                        value: _vm.emailStatusText,
                      },
                    })
                  : _vm._e(),
                _vm.user.archived
                  ? _c("Badge", {
                      staticClass: "text-storm-gray bg-gray-tabs capitalize",
                      attrs: {
                        value: "Archived",
                        color: "text-storm-gray",
                        styleClasses: "h-auto py-0.5 px-2",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex flex-row gap-2 items-center" },
              [
                _c("ToggleFavoriteTalentMapping", {
                  attrs: {
                    currentUserId: _vm.currentUserId,
                    contractorUserId: _vm.employeeUserId,
                    favorites: _vm.favoritedByUsers,
                    didLike: _vm.favoritedByUsers.length > 0,
                  },
                  on: { updated: _vm.onUpdateToggleCard },
                }),
                !_vm.isCardDisabled
                  ? _c(
                      "button",
                      {
                        on: {
                          click: _vm.message,
                          mouseover: function ($event) {
                            _vm.isHoveredChat = true
                          },
                          mouseout: function ($event) {
                            _vm.isHoveredChat = false
                          },
                        },
                      },
                      [
                        !_vm.isHoveredChat
                          ? _c("ChatIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHoveredChat
                          ? _c("ChatIconHover", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "resource_info_section flex" }, [
          _c(
            "div",
            {
              staticClass:
                "flex w-full justify-start h-fit mt-2 resource_info_left",
            },
            [
              _c(
                "RouterLink",
                { attrs: { to: _vm.contractorPageRoute } },
                [
                  _c("ResourceAvatar", {
                    staticClass: "cursor-pointer text-primary-600",
                    attrs: {
                      image: _vm.managerAvatar,
                      initial: _vm.managerInitials,
                      disabled: _vm.isCardDisabled,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "resource_info_right" },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-start pt-2" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "mr-[40px]",
                      attrs: { to: _vm.contractorPageRoute },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-medium text-lg text-default-500 hover:text-primary-500 flex flex-row items-center cursor-pointer gap-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-row blueTexts" },
                            [_vm._v(" " + _vm._s(_vm.FullName) + " ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "text-default-500 text-base font-normal items-center",
                },
                [
                  _c("p", { staticClass: "mr-2" }, [
                    _vm._v(_vm._s(_vm.jobTitle ? _vm.jobTitle : "n/a")),
                  ]),
                  _c("p", { staticClass: "mr-2" }, [
                    _vm._v(_vm._s(_vm.companyName ? _vm.companyName : "n/a")),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex text-default-grey text-sm font-normal" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.managerLocation ? _vm.managerLocation : "n/a"
                      ) +
                      " "
                  ),
                ]
              ),
              _c("ContractorRating", {
                staticClass: "flex items-center w-full mb-1 pt-2",
                attrs: {
                  ratingTotal: _vm.ratingTotal,
                  ratingCount: _vm.ratingCount,
                  parentClasses: "mapping_rating_class",
                },
              }),
              _vm.maxmin.min && _vm.maxmin.max
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center w-full bg-gray-100",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "projects-value flex flex-col" },
                        [
                          _c("p", { staticClass: "text-sm" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.maxmin.min) +
                                "-" +
                                _vm._s(_vm.maxmin.max) +
                                _vm._s(
                                  _vm.ratingUnit ? `/${_vm.ratingUnit}` : ""
                                )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "projects-name text-gray-500" },
                        [_vm._v(" Rate ")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }